// extracted by mini-css-extract-plugin
export default {"menuBlock":"iG-z","title":"jG-z","nav":"kG-z","flexCell":"lG-z","facetLink":"mG-z"};